// extracted by mini-css-extract-plugin
export default {"shift-preset-month":"shift-preset-month--jSmi7 event-month--atv6w","shiftPresetMonth":"shift-preset-month--jSmi7 event-month--atv6w"};